import { combineReducers } from 'redux';

import cancelError from './cancelError';
import createError from './createError';

export default combineReducers({
  cancelError,
  createError,
});
